import React from 'react';

export default function SearchBar() {
  return (
    <div className="bg-[#232426] border-b border-[#515153] h-[48px] flex items-center px-3 md:px-4 flex-shrink-0 gap-2 md:gap-4 z-10">
      <div className="flex flex-1 max-w-[700px] bg-[#323335] border border-[#515153] rounded-[4px] h-[30px] overflow-hidden focus-within:border-[#737478]">
        <button className="hidden sm:flex px-3 border-r border-[#515153] text-[#b3b4b7] text-[13px] items-center gap-1.5 hover:bg-[#3e3f42]">
          context
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9l6 6 6-6" /></svg>
        </button>
        <input type="text" placeholder="Search your space" className="bg-transparent flex-1 border-none outline-none text-white px-3 text-[13px] placeholder-[#8f9196] min-w-0" />
        <button className="hidden sm:flex px-3 border-l border-[#515153] text-[#b3b4b7] text-[13px] items-center gap-1.5 hover:bg-[#3e3f42]">
          context
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9l6 6 6-6" /></svg>
        </button>
        <button className="w-[36px] md:w-[40px] border-l border-[#515153] text-[#b3b4b7] hover:bg-[#3e3f42] flex items-center justify-center transition-colors">
          <svg className="w-[14px] h-[14px] md:w-[15px] md:h-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" /></svg>
        </button>
      </div>
      <a href="#" className="hidden sm:flex text-[#8f9196] text-[13px] items-center gap-1.5 hover:text-[#d5d6d9] font-medium flex-shrink-0">
        <svg className="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
        How to use
      </a>
    </div>
  );
}
